import { RecursiveObject, theme } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'

export const borders = {}

export const radii = {}

export const fonts = {
  heading: `Sharp Sans, ${theme.fonts.heading}`,
  body: `Product Sans, ${theme.fonts.body}`,
}

export const shadows = {
  up: '4px -7px 15px 0px #AEB1FF21, 0px 5px 14px 0px #00000078, -1px 1px 2px 0px #80BAFF3D inset',
  down: '-1px 1px 3px 0px #7EA2FF42, -9px 12px 24px 0px #0D11177D inset, 0px -5px 5px 0px #FFFFFF05 inset',
  'mini-down': 'inset 0px 1px 2px rgba(0, 0, 0, 0.33)',
  outline: '0 0 0 3px transparent',
}
